import { Outlet } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientDashboard as ClientDashboardComponent } from "@components/Dashboards";

import { routes } from "@pages/routes";

export const ClientDashboard = () => {
  const { clientId } = useTypedParams(routes.portal.clients.client.dashboard);

  return (
    <>
      <ClientDashboardComponent clientId={clientId} />
      <Outlet />
    </>
  );
};
